import { css, keyframes } from 'styled-components';

export const FadeInTransition = keyframes`
from {
    opacity: 0;
}

to {
    opacity: 1;
}
`;

export const SlideUpTransition = keyframes`
    from {
        transform: translateY(5rem);
    }
    to {
        transform: translateY(0);
    }
`;

export const SlideLeftTransition = keyframes`
    from {
        transform: translateX(5rem);
    }
    to {
        transform: translateX(0);
    }
`;

export const ScaleUpTransition = keyframes`
    from {
        transform: scale(0.8);
    }
    to {
        transform: scale(1);
    }
`;

export const defaultFadeInAnimation = (delay: number = 0, duration: number = 0.5) => css`${FadeInTransition} ${duration}s ease-in-out ${delay}s both`;
export const defaultSlideUpAnimation = (delay: number = 0, duration: number = 0.5) => css`${SlideUpTransition} ${duration}s ease-in-out ${delay}s both`;
export const defaultSlideLeftAnimation = (delay: number = 0) => css`${SlideLeftTransition} 0.5s ease-in-out ${delay}s both`;
export const defaultScaleUpAnimation = (delay: number = 0) => css`${ScaleUpTransition} 0.5s cubic-bezier(.43,1.74,.68,1) ${delay}s both`;
